<template>
  <div id="app" class="px-6 pt-4 pb-6 flex flex-col h-screen">

    <div class="font-serif text-lg lg:text-2xl font-bold mb-2 px-6 max-w-3xl mx-auto lg:ml-0 lg:mr-auto xl:mx-0 xl:px-12 xl:w-3/4">
      <h1 class="">宝貝データ早見表</h1>
    </div>

    <div class="sm:flex -mx-3 mb-6">
      <div class="w-full sm:w-1/3 px-3 mb-2 sm:mb-0">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">クラス</label>
          <div class="relative">
              <select class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" v-model="className">
                  <option v-for="c in classNames" v-bind:key="c">{{ c }}</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
          </div>
      </div>
      <div class="w-full sm:w-1/3 px-3 mb-2 sm:mb-0">
        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">効果</label>
        <div class="relative">
          <select class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" v-model="ability">
            <option v-for="a in abilityNames" v-bind:key="a">{{ a }}</option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>
      <div class="w-full sm:w-1/3 px-3 mb-2 sm:mb-0">
        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">等級</label>
        <div class="relative">
          <select class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" v-model="rarity">
            <option v-for="r in rarityNames" v-bind:key="r">{{ r }}</option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-1 border overflow-auto scrollbar-w-2 scrollbar-track-gray-lighter scrollbar-thumb-rounded scrollbar-thumb-gray scrolling-touch">
      <table class="relative w-full text-center table-collapse">
        <thead>
          <tr>
            <th class="sticky top-0 z-20 w-24 bg-gray-400">&nbsp;</th>
            <th class="sticky top-0 z-20 w-24 font-serif text-base font-semibold text-gray-700 p-2 bg-gray-400" v-for="(n, i) in 16" v-bind:key="i">+{{ i }}</th>
          </tr>
        </thead>
        <tbody class="align-baseline">
          <tr class="border-t border-gray-200" v-for="(n, j) in 21" v-bind:key="j">
            <th class="sticky left-0 z-10 p-2 font-serif text-sm font-semibold text-gray-100 whitespace-no-wrap bg-gray-500">{{ 80 + j }}%</th>
            <td class="p-2 font-serif text-sm text-gray-600 whitespace-no-wrap" :class="{ 'bg-white': j % 2 === 0, 'bg-gray-100': j % 2 !== 0 }" v-on:click="highlight" v-for="(n, k) in 16" v-bind:key="k">{{ calc(className, ability, rarity, k, (80 + j) / 100) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      baseAbilities: {
        '猛将': {
          '体力': 3440,
          '防御度': 855,
          '致命打発生率': 90,
          '致命打攻撃力': 120,
          '元素ダメージ': 360,
          '物理ダメージ': 360
        },
        '勇将': {
          '体力': 3100,
          '防御度': 570,
          '致命打発生率': 75,
          '致命打攻撃力': 126,
          '元素ダメージ': 396,
          '物理ダメージ': 396
        },
        '射手': {
          '体力': 2924,
          '防御度': 525,
          '致命打発生率': 75,
          '致命打攻撃力': 129,
          '元素ダメージ': 414,
          '物理ダメージ': 414
        },
        '君主': {
          '体力': 1920,
          '防御度': 510,
          '致命打発生率': 105,
          '致命打攻撃力': 132,
          '元素ダメージ': 324,
          '物理ダメージ': 324
        },
        '策士': {
          '体力': 2000,
          '防御度': 285,
          '致命打発生率': 75,
          '致命打攻撃力': 120,
          '元素ダメージ': 432,
          '物理ダメージ': 432
        }
      },
      rarities: {
        '神話': 1.33,
        '伝説': 1,
        'レア': 0.66,
        '通常': 0.33
      },
      abilityMultipliers: {
        '体力': [1, 1.05, 1.1, 1.175, 1.25, 1.325, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2, 2.125, 2.25, 2.5],
        '防御度': [1, 1+2/30, 1.1+1/30, 1.2+1/30, 1+1/3, 1.4+2/30, 1.6, 1.7+1/30, 1.8+2/30, 2, 2.1+2/30, 2+1/3, 2.5, 2+2/3, 3, 10/3],
        '致命打発生率': [1, 1+2/30, 1.1+1/30, 1.2+1/30, 1+1/3, 1.4+2/30, 1.6, 1.7+1/30, 1.8+2/30, 2, 2.1+2/30, 2+1/3, 2.5, 2+2/3, 3, 10/3],
        '致命打攻撃力': [1, 1+2/30, 1.1+1/30, 1.2+1/30, 1+1/3, 1.4+2/30, 1.6, 1.7+1/30, 1.8+2/30, 2, 2.1+2/30, 2+1/3, 2.5, 2+2/3, 3, 10/3],
        '元素ダメージ': [1, 1+2/30, 1.1+1/30, 1.2+1/30, 1+1/3, 1.4+2/30, 1.6, 1.7+1/30, 1.8+2/30, 2, 2.1+2/30, 2+1/3, 2.5, 2+2/3, 3, 10/3],
        '物理ダメージ': [1, 1+2/30, 1.1+1/30, 1.2+1/30, 1+1/3, 1.4+2/30, 1.6, 1.7+1/30, 1.8+2/30, 2, 2.1+2/30, 2+1/3, 2.5, 2+2/3, 3, 10/3]
      },
      className: '猛将',
      ability: '防御度',
      rarity: '神話'
    }
  },
  methods: {
    calc: function (c, a, r, s, q) {
      var m = (a === '物理ダメージ') ? 0.8 : 1;
      return parseInt(parseInt(Math.round(this.baseAbilities[c][a] * this.rarities[r] * this.abilityMultipliers[a][s]) * m) * q);
    },
    highlight: function (e) {
      e = e || window.event;
      var targetEl = e.target || e.srcElement;
      if (targetEl.classList.contains('bg-red-200')) {
        targetEl.classList.remove('bg-red-200');
      } else {
        targetEl.classList.add('bg-red-200');
      }
    }
  },
  computed: {
    classNames () {
      return Object.keys(this.baseAbilities);
    },
    abilityNames () {
      return Object.keys(this.abilityMultipliers);
    },
    rarityNames () {
      return Object.keys(this.rarities);
    }
  }
}
</script>

<style>

</style>
